import ControlsStatus  from './Constants/ControlsStatus';
import FrameStatus     from './Constants/FrameStatus';
import WatermarkStatus from './Constants/WatermarkStatus';
import IFrame          from './Interfaces/IFrame';

class Frame implements IFrame {
    public frameStatus: FrameStatus = FrameStatus.WINDOWED;
    public controlsStatus: ControlsStatus = ControlsStatus.ACTIVE;
    public watermarkStatus: WatermarkStatus = WatermarkStatus.HIDDEN;
    public isFocused: boolean = false;
    public isSettingsOpen: boolean = false;

    public get isFrameWindowed(): boolean {
        return this.frameStatus === FrameStatus.WINDOWED;
    }

    public get isFrameFullscreened(): boolean {
        return this.frameStatus === FrameStatus.FULLSCREENED;
    }

    public get areControlsActive(): boolean {
        return this.controlsStatus === ControlsStatus.ACTIVE;
    }

    public get areControlsIdle(): boolean {
        return this.controlsStatus === ControlsStatus.IDLE;
    }

    public get isWatermarkShown(): boolean {
        return this.watermarkStatus !== WatermarkStatus.HIDDEN;
    }
}

export default Frame;